import { render, staticRenderFns } from "./two_module.vue?vue&type=template&id=79623b64"
import script from "./two_module.vue?vue&type=script&lang=js"
export * from "./two_module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports